import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useNavigate } from "react-router-dom";

const ModalSolicitudes = () => {
  const [modal, setModal] = useState(false);
  const navigate = useNavigate();

  const toggle = () => setModal(!modal);

  const handleRedirect = (path) => {
    setModal(false);
    navigate(path);
  };

  return (
    <div>
      <Button color="primary" onClick={toggle}>
        Nueva Solicitud
      </Button>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Solicitudes</ModalHeader>
        <ModalBody>
          <Button
            color="success"
            block
            onClick={() => handleRedirect("/admin/CrearSolicitud")}
          >
            Solicitud Abastecimiento
          </Button>
          <Button
            color="info"
            block
            onClick={() => handleRedirect("/CreaCasosJuridica")}
          >
            Solicitud Jurídica
          </Button>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ModalSolicitudes;
